import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useMutation } from "react-query";
import { useAuth } from "../../../contexts/Auth";
import { usePremium } from "../../../contexts/Premium";
import { deleteAccount } from "../../../services/userApi";
import { trackEvent } from "../../../shared/analytics";

const Settings = () => {
  const { setIsPremium } = usePremium();
  const { authData, signOut } = useAuth();
  const toast = useToast();
  const mutation = useMutation(({ userId }) => {
    return deleteAccount(userId);
  });

  const onClickDeleteAccount = () => {
    if (window.confirm("Are you sure you want to delete your account?")) {
      // delete account
      mutation
        .mutateAsync({ userId: authData.id })
        .then(() => {
          trackEvent("account_deleted");
          toast({
            title: "Account deleted",
            description: `Your account has been deactivated and marked for deletion.`,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setIsPremium(false);
          signOut();
        })
        .catch((err) => console.error(err));
    }
  };
  return (
    <Container>
      <Box width="100%" py="12">
        <VStack spacing="6" alignItems="stretch">
          <Heading as="h2" size="lg" marginBottom="16px">
            Settings
          </Heading>
          <Box bg="gray.700" borderRadius="lg" p="6">
            <Heading as="h3" size="sm">
              Danger zone
            </Heading>
            <Box
              borderColor="red.600"
              borderWidth="1px"
              borderRadius="lg"
              p="3"
              mt="6"
            >
              <Heading as="h6" size="xs" pb="3">
                Delete my account?
              </Heading>
              <Text>
                If you delete your account now, you will have the option to
                recover it within 14 days by contacting our support. After that,
                you won't be able to recover it and will lose access to your
                data.
                <br />
                <br />
                If you have a Premium subscription through your Google Play or
                App Store, make sure to cancel it.
                <br />
                <br />
                <Button
                  colorScheme="red"
                  variant="outline"
                  onClick={() => onClickDeleteAccount()}
                >
                  Delete my account
                </Button>
              </Text>
            </Box>
          </Box>
        </VStack>
      </Box>
    </Container>
  );
};

export default Settings;
